<template>
  <div class="filter">
    <!-- 검색어 -->
    <div class="innerItem filterInput">
      <p class="innerTitle toCapitalize f_medium" :placeholder="locale.search_placeholder">{{locale.search}}</p>
      <input type="text" class="input" :placeholder="locale.search_placeholder" v-model="categoryFilter.word">
    </div>
    <!-- //검색어 -->
    <!-- 카테고리 -->
    <div class="innerItem filterCategory">
      <p class="innerTitle toCapitalize f_medium">{{locale.category}}</p>
      <div class="item"
        v-for="item in category"
        :key="item"
        :data-category="item"
        :class="{active: categoryFilter.list.includes(item)}">
        <div class="checkbox">
          <input type="checkbox" :id="`filter_${item}`" :value="item" v-model="categoryFilter.list">
          <label :for="`filter_${item}`">{{amenityCategory(item)}}</label>
        </div>
      </div>
    </div>
    <!-- //카테고리 -->
    <!-- 서비스상태 -->
    <div class="innerItem">
      <p class="innerTitle toCapitalize f_medium">{{locale.amenity_state_service}}</p>
      <div class="flexBox">
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_service_on"
            v-model="listView.serviceOn"
            :disabled="listView.serviceOn && !listView.serviceOff"
            @change="setListView" />
          <label for="view_service_on">{{locale.amenity_state_service_on}}</label>
        </span>
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_service_off"
            v-model="listView.serviceOff"
            :disabled="!listView.serviceOn && listView.serviceOff"
            @change="setListView" />
          <label for="view_service_off">{{locale.amenity_state_service_off}}</label>
        </span>
      </div>
    </div>
    <!-- //서비스상태 -->
    <!-- 요청가능상태 -->
    <div class="innerItem">
      <p class="innerTitle toCapitalize f_medium">{{locale.amenity_state_request}}</p>
      <div class="flexBox">
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_service_enabled"
            v-model="listView.enabled"
            :disabled="listView.enabled && !listView.disabled"
            @change="setListView" />
          <label for="view_service_enabled">{{locale.amenity_state_request_on}}</label>
        </span>
        <span class="checkbox flexInner">
          <input type="checkbox" id="view_service_disabled"
            v-model="listView.disabled"
            :disabled="!listView.enabled && listView.disabled"
            @change="setListView">
          <label for="view_service_disabled">{{locale.amenity_state_request_off}}</label>
        </span>
      </div>
    </div>
    <!-- //요청가능상태 -->
  </div>
</template>

<script>
export default {
  props: [
    'locale'
  ],
  computed: {
    category () {
      return this.$store.getters['amenity/getCategory']
    },
    categoryFilter: {
      get () {
        return this.$store.getters['amenity/getFilter']
      },
      set (val) {
        const data = {
          word: val.word, // 검색어는 대소문자, 공백 무시
          list: val.list
        }
        this.$store.commit('amenity/setFilter', data)
      }
    }
  },
  created () {
    this.init()
  },
  data () {
    return {
      /**
       * 리스트 보기 옵션
       * 서비스중: serviceOn
       * 비서비스: serviceOff
       * 일시중지: disabled
       */
      listView: {
        serviceOn: true,
        serviceOff: false,
        enabled: true,
        disabled: true
      }
    }
  },
  methods: {
    init () {
      this.setListView()
      this.$store.commit('amenity/initFilter')
    },
    setListView () {
      this.$store.commit('amenity/listView', this.listView)
    },
    amenityCategory (categoryName) {
      const category = `amenity_category_${categoryName}`
      return this.locale[category]
    }
  }
}
</script>

<style lang="scss" scoped>
.flexBox {
  margin-left: 0;
  margin-right: 0;
  .flexInner {
    padding-left: 0;
    padding-right: 0;
  }
}
.filterCategory {
  .item {
    position: relative;
    margin-bottom: 15px;
    padding: 1.2em 1em 1.2em 30px;
    border: 1px solid $color-lgrey2;
    background-color: $color-white;
    &:before {
      content: "";
      position: absolute;
      top: 50%;
      left: 10px;
      width: 10px;
      height: 10px;
      margin-top: -5px;
      opacity: 0.2;
    }
    &.active:before {
      opacity: 1;
    }
  }
  .checkbox {
    display: block;
  }
}
</style>
